<template>
  <div class="l-driver">
    <h2>Find drivers for your printer.</h2>
    <AppDropdown
      :iconName="system.iconName"
      :dropdownOpen="dropdownOpen"
      :toggler="togglerText"
    >
      <div
        v-for="(printer, index) in printers"
        :key="index"
        class="c-dropdown__list-item"
      >
        <div
          class="c-card c-card--dark"
          @click="selectPrinter(printer)"
        >
          <div class="c-card__title">{{ printer.name }}</div>
          <div class="c-card__info">{{ printer.driver }}</div>
        </div>
      </div>
    </AppDropdown>
  </div>
</template>

<script>
import AppDropdown from './AppDropdown';

export default {
  name: 'ChooseDriver',

  components: {
    AppDropdown,
  },

  props: {
    system: {
      iconName: {
        type: String,
        required: true
      },
    },
    printers: {
      type: Array,
      required: true,
    },
    selectedPrinter: {
      name: {
        type: String,
        required: true,
      },
    },
  },

  data() {
    return {
      dropdownOpen: false,
    };
  },

  computed: {
    togglerText: function() {
      return this.selectedPrinter.name || 'Driver is not chosen.';
    }
  },

  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    selectPrinter(printer) {
      this.$emit('onSelectPrinter', printer);
      this.toggleDropdown();
    },
  },
};
</script>

<style></style>
